import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useStore } from '../stores/store'

const Dashboard = () => {
  const { userStore } = useStore()

  useEffect(() => {
    userStore.loadAllUsers()
  }, [userStore])

  return (
    <Container className='CB mt-4 pt-5'>
      <Row>
        <Col style={{ minWidth: '382px' }}>
          <div className='card m-3'>
            <div className='card-body cardBackground'>
              <img
                style={{ width: '100px', display: 'block', margin: '0 auto' }}
                src='/images/user.png'
                alt=''
              />
              <h5 className='card-title mt-2'>Total Users:</h5>
              <p className='card-text'>{userStore.totalUsers}</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
export default observer(Dashboard)
